import type {ConnectElementConfig} from '../../../connect/ConnectJSInterface/ConnectElementList';
import {ComponentOverrideFlag} from '../../../utils/flags/flags';

export const defaultFinancingOfferParameter =
  'default-financing-offer' as const;
export const showFinancingSelectorParameter =
  'show-financing-selector' as const;
export const howCapitalWorksUrlParameter = 'how-capital-works-url' as const;
export const supportUrlParameter = 'support-url' as const;
export const capitalSchemeParameter = 'capital-scheme' as const;

export const CapitalFinancingConfig: ConnectElementConfig = {
  Component: () => import('../../../components/Capital/CapitalFinancing'),
  enabledKey: 'capital_financing',
  enabledOverrideFlag: ComponentOverrideFlag.capital_financing,
  htmlAttributes: {
    [defaultFinancingOfferParameter]: {
      isInternal: false,
    },
    [showFinancingSelectorParameter]: {
      isInternal: false,
    },
    [howCapitalWorksUrlParameter]: {
      isInternal: false,
    },
    [supportUrlParameter]: {
      isInternal: false,
    },
    // Internal - to enable these for platforms, we'll need API review
    [capitalSchemeParameter]: {
      isInternal: true,
    },
  },
  htmlEvents: ['onfinancingsloaded'],
  customHtmlElementMethods: {
    setDefaultFinancingOffer: {
      type: 'AttributeSettingMethod',
      attribute: defaultFinancingOfferParameter,
      isInternal: false,
      description: 'Sets the default financing offer to display',
    },
    setShowFinancingSelector: {
      type: 'AttributeSettingMethod',
      attribute: showFinancingSelectorParameter,
      isInternal: false,
      description:
        'Controls displaying the financing dropdown selector to allow the merchant to change the focused financing',
    },
    setHowCapitalWorksUrl: {
      type: 'AttributeSettingMethod',
      attribute: howCapitalWorksUrlParameter,
      isInternal: false,
      description: 'Sets the "How Capital Works" url to display',
    },
    setSupportUrl: {
      type: 'AttributeSettingMethod',
      attribute: supportUrlParameter,
      isInternal: true,
      description: 'Sets the support url to display',
    },
    setOnFinancingsLoaded: {
      type: 'EventListenerMethod',
      event: 'onfinancingsloaded',
      isInternal: false,
      description:
        'Sets the event listener that allows a user to pass in a callback function that provides a total financings loaded count.',
    },
    // Internal - to enable these for platforms, we'll need API review
    setCapitalScheme: {
      type: 'AttributeSettingMethod',
      attribute: capitalSchemeParameter,
      isInternal: true,
      description:
        'Sets the CapitalScheme value, used to indicate when the component is rendering in certain Stripe-owned surfaces.',
    },
  },
  releaseState: 'preview',
  sentryTeam: 'capital_for_platforms',
  teamOwner: 'capital-for-platforms',
  description:
    'Shows balance and reporting information for active accepted loans or past accepted loans',
};
